export function validateStep(stepKey, allData) {
  switch (stepKey) {
    case "step1": {
      const title = allData.step1?.title;
      const firstTitle =
        Array.isArray(title) && title.length > 0
          ? title.find((entry) => (entry?.value ?? "").trim() !== "")?.value ??
            ""
          : "";

      return Boolean(allData.step1?.name?.trim() || firstTitle.trim());
    }

    case "step2": {
      const ids = allData.step2?.configById;
      return Array.isArray(ids) && ids.length > 0;
    }

    case "step3":
      return (
        Array.isArray(allData.step3?.selectedIris) &&
        allData.step3.selectedIris.length > 0
      );

    case "step4":
    default:
      return true;
  }
}
